export default {
  login: "WhiteWolfWCY",
  id: 52237339,
  node_id: "MDQ6VXNlcjUyMjM3MzM5",
  avatar_url: "https://avatars.githubusercontent.com/u/52237339?v=4",
  gravatar_id: "",
  url: "https://api.github.com/users/WhiteWolfWCY",
  html_url: "https://github.com/WhiteWolfWCY",
  followers_url: "https://api.github.com/users/WhiteWolfWCY/followers",
  following_url:
    "https://api.github.com/users/WhiteWolfWCY/following{/other_user}",
  gists_url: "https://api.github.com/users/WhiteWolfWCY/gists{/gist_id}",
  starred_url:
    "https://api.github.com/users/WhiteWolfWCY/starred{/owner}{/repo}",
  subscriptions_url: "https://api.github.com/users/WhiteWolfWCY/subscriptions",
  organizations_url: "https://api.github.com/users/WhiteWolfWCY/orgs",
  repos_url: "https://api.github.com/users/WhiteWolfWCY/repos",
  events_url: "https://api.github.com/users/WhiteWolfWCY/events{/privacy}",
  received_events_url:
    "https://api.github.com/users/WhiteWolfWCY/received_events",
  type: "User",
  site_admin: false,
  name: "Mateusz Martyna",
  company: null,
  blog: "https://portfolio-eight-kappa-66.vercel.app/",
  location: "Lublin, Poland",
  email: null,
  hireable: null,
  bio: null,
  twitter_username: "mateusz_mww",
  public_repos: 9,
  public_gists: 0,
  followers: 0,
  following: 1,
  created_at: "2019-06-26T08:37:59Z",
  updated_at: "2023-12-26T22:59:39Z",
};
